import { CSSObject } from '@emotion/react'

export const svg: CSSObject = {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  strokeLinejoin: 'round',
  strokeMiterlimit: 2,
  fill: 'rgba(255, 255, 255, 0.95)',
}

export const path: CSSObject = { fillRule: 'nonzero' }
